export default __webpack_public_path__ + "static/media/powered-by-stripe.c02b437d.svg";